import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";
import { FitText, formatDateTimeFromISO, isMidnightFromISO } from "widgets";

import style from "../styles/Cell.module.css";

export const DateCell = (props: CustomCellRendererProps) => {
  const value = String(props.value ?? "");
  const hideTime = isMidnightFromISO(value);
  /**
   * Display falls back to more compact formats depending on available width.
   *
   * Example (for "2011-12-11T11:32:00.000Z"):
   * - `full`: "Sunday, December 11, 2011 at 11:32 AM"
   * - `short`: "Dec 11, 2011, 11:32 AM"
   * - `numericDateTime`: "12/11/2011, 11:32" (localized numeric date + numeric time)
   * - `numericDate`: "12/11/2011" (localized numeric date)
   *
   * If the time is midnight (00:00), the time part is omitted.
   */
  const full = formatDateTimeFromISO(value, { full: true, hideTime });
  const short = formatDateTimeFromISO(value, { hideTime });
  const numericDateTime = formatDateTimeFromISO(value, { format: "numeric", hideTime });
  const numericDate = formatDateTimeFromISO(value, { format: "numeric", hideTime: true });

  return (
    <div className={clsx(style.cell, style.truncate_container)}>
      <span className={style.truncate_autosize} aria-hidden>{full}</span>
      <FitText
        candidates={[full, short, numericDateTime, numericDate]}
        tooltipText={full}
        className={clsx(style.truncate_content, style.right_aligned)}
      />
    </div>
  );
};
